<div class="container" role="main">
    <div class="HmsContainer">
        <div class="row">
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"></div>
                <div class="col-xs-12 col-sm-12 col-md-11 col-lg-11">
                    <form class="finalForm" [formGroup]="finalForm" (ngSubmit)="finalDetailsSubmit()">
                        <div class="row">
                            <div class="col-md-10" [innerHtml]="confirmationmsg">
                            </div>
                            <p role="heading" aria-level="1">
                                You may close this browser or hit the 'Enter New Referral' button to return to start a
                                new referral
                            </p>
                            <div class="col-md-10">
                                <button type="submit" class="btn orangeBtn" [disabled]="finalForm.invalid"
                                    [ngStyle]="{'background-color': primaryColor}">Enter New Referral</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>